import { TableColumn } from '../../table/DataTable.types';

export const columns: TableColumn[] = [
  {
    accessor: 'name',
    name: 'page.file.col-name',
  },
  {
    accessor: 'sizeInMegaBytes',
    name: 'page.file.col-size',
    cellRenderer: (val) => val.sizeInMegaBytes + ' MB',
  },
];
